export default __webpack_public_path__ + "static/media/brain.5157b264.png";